/* eslint-disable react-hooks/exhaustive-deps */
import { WriterContent, WriterType } from "src/modules/pe-landing-module/data/interfaces"
import "../../../assets/css/writer.scss"
import { IPrimitiveProps } from "../section/Primitive"
import Pushkin from "./writer/Pushkin"
import Scramble from "./writer/Scramble"
import Jumper from "./writer/Jumper"

/* Protopia Ecosystem component */
export interface IHTMLPrimitiveProps {
   
}
const WriterPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: WriterContent = (props.primitive || {}) as WriterContent 
    switch(primitive.writerType) {
        case WriterType.SCRAMBLE:
            return <Scramble {...props} />
        case WriterType.JUMPER:
            return <Jumper {...props} />
        case WriterType.PUSHKIN:
        default:
            return <Pushkin {...props} />
    }
}
export default WriterPrimitive

export const  SCRAMBLES = "!<>-_\\/[]{}—=+*^?#ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789________"